﻿"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const operational_context_client_1 = require("@its-suite/operational-context-client");
const app_commons_1 = require("@its-suite/app-commons");
const ReactLocalizeRedux = require("react-localize-redux");
function getDefaultResources(resources, invariantResources) {
    let currentCulture = getCurrentCulture(resources);
    app_commons_1.Locale.set(currentCulture);
    let options = {
        defaultLanguage: currentCulture
    };
    let languages = Object.values(resources.reduce((prev, l) => {
        if (l.locale && !prev[l.locale]) {
            return Object.assign(Object.assign({}, prev), { [l.locale]: {
                    name: invariantResources[l.locale],
                    code: l.locale
                } });
        }
        else {
            return prev;
        }
    }, {}));
    return { languages, options };
}
exports.getDefaultResources = getDefaultResources;
function getCurrentCulture(resources) {
    let currentCulture = app_commons_1.Locale.get();
    if (currentCulture === null) {
        currentCulture = app_commons_1.Locale.getDefaultLocale();
    }
    if (!isCultureAvailable(resources, currentCulture)) {
        let culturesToApplyInOrder = [];
        if (app_commons_1.LocalizationUtils.isCultureLocalized(currentCulture)) {
            culturesToApplyInOrder.push(app_commons_1.LocalizationUtils.getCultureLanguagePart(currentCulture));
        }
        culturesToApplyInOrder.push(resources[0].locale);
        for (let cultureName of culturesToApplyInOrder) {
            if (isCultureAvailable(resources, cultureName)) {
                currentCulture = cultureName;
                break;
            }
        }
    }
    return currentCulture;
}
function isCultureAvailable(resources, cultureName) {
    return resources.some(d => d.locale === cultureName);
}
function ownGetTranslate(state) {
    return function translate(text, file) {
        if (!file) {
            file = operational_context_client_1.DefaultResourceFiles.Resources.toString();
        }
        let key = `${file}-${text}`;
        return ReactLocalizeRedux.getTranslate(state)(key);
    };
}
exports.ownGetTranslate = ownGetTranslate;
//# sourceMappingURL=localization.js.map